import React, { useState, useContext, useEffect } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";

import {AppContext } from "../../AppContext";
import { LogInfo, LogError } from "../../common/FetchHelpers";

import LoadingComp from "../common/LoadingComp";

const ResetPassComp = () => {
  const history = useHistory();
  const location = useLocation();
  const [appContext,setAppContext] = useContext(AppContext);

  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showInvalidTokenMsg, setShowInvalidTokenMsg] = useState(false);
  const [showInputPanel, setShowInputPanel] = useState(false);
  const [showConfirmationMsg, setShowConfirmationMsg] = useState(false);

  const [messageData, setMessageData] = useState("Error");
  const [histCount, setHistCount] = useState();
  const qparams = useParams();  
  
  const [formData, setFormData] = useState({ newPassword: "", confirmPassword: "" });

  let { from } = location.state || { from: { pathname: "/home"} };

  
  const validatePasswordResetToken = () => {
    if(qparams.password_reset_token && qparams.password_reset_token !== ''){
      setLoading(true);
      fetch('/auth/ValidatePasswordResetToken', {
      method: "POST",
      cache: "no-cache",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId:  qparams.password_reset_token}),
    })
    .then(response => response.json())
    .then(result => {
      if(result.success === true){
        setLoading(false);
        setHistCount(result.message);
        setShowInputPanel(true);
      }
      else{
        setLoading(false);
        setShowInvalidTokenMsg(true);
      }
    })
    .catch(error => {
      setLoading(false);
      setShowError(true);
    });

    }
    else{
      setLoading(false);
      setShowInvalidTokenMsg(true); //invalid token
    }
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
    
  }
  const validatePassword = () => {
    //console.log('validatePassword() ');
    //console.log(JSON.stringify(formData));    
    setLoading(false);
    if(!formData.newPassword){
      setMessageData("Password cannot be empty.");      
      setShowError(true);        
      return;
    }
    if(!isValidPassword(formData.newPassword)){
      setMessageData("Password is not strong.");
      setShowError(true);        
      return;
    }
    if(formData.newPassword !== formData.confirmPassword){
      setMessageData("New and confirmed passwords do nto match.");
      setShowError(true);        
      return;
    }
    setShowError(false);        
  }

  const isValidPassword = (password) => {
    return /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{8,})$/.test(password);
  }

  const handleSubmit = (event) => {    
    setLoading(true);
    event.preventDefault();
    fetch('/auth/ResetPassword', {
      method: "POST",
      cache: "no-cache",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: qparams.password_reset_token,password:formData.newPassword }),
    })
    .then(response => response.json())
    .then(result => {
      if(result.success === true){
        setLoading(false);
        setShowInputPanel(false);
        setShowConfirmationMsg(true);
      }
      else{
        setMessageData(result.message);
        setLoading(false);
        setShowError(true);        
      }
    })
    .catch(error => {
      setLoading(false);
      setShowError(true);
    });

  };

  
  useEffect(() => {
    validatePasswordResetToken();
  }, []);

  useEffect(() => {
    validatePassword();
  }, [formData]);

  return (    
      <div className="center-container">
        <form onSubmit={handleSubmit} className="form login-form" id="login-page">
          <h3 className="login-header">Reset Password</h3>
          {showInputPanel && (
            <div>
          <div className="form-body">
            Password must meet the following requirements:
            <ul>
              <li className="list-item"> At least 8 characters long</li>
              <li className="list-item"> Contain at least one capital letter</li>
              <li className="list-item"> Contain at least one number</li>
              <li className="list-item"> Password cannot contain login id</li>
              { histCount && (<li className="list-item">  You cannot reuse any of your last {histCount} passwords</li>)}
            </ul>
            <div className="form-row">
            <div className="form-desc ">  </div>
            </div>

            <div className="form-row">
              <div className="form-item">
                <label className="form-item-label">New Password : </label>
                <input name="newPassword" className="form-item-value" type="password" placeholder="new password" onChange={handleChange} disabled={loading ? "disabled" : "" }/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-item">
                <label className="form-item-label">Confirm Password : </label>
                <input name="confirmPassword" className="form-item-value" type="password" placeholder="confirm password" onChange={handleChange} disabled={loading ? "disabled" : ""}/>
              </div>
            </div>
          </div>
          
          
          <div className="form-footer">
            <div className="form-status red">
              {showError && (
                <div className="form-status red">
                  {messageData}
                </div>
              )}
              {loading && <LoadingComp small={true} />}
            </div>
            <div className="btn-group">
              <button id="btnResetPassword" type="submit" className="btn btn-primary">
                Save New Password
              </button>
            </div>
          </div>
          </div>
          )}
          {showInvalidTokenMsg && (
            <div className="form-body">
            <div className="form-desc red"> Password reset URL is invalid. </div>
            <div className="info-label"></div>
            <div  className="center-container">
                  <button id="btnBackToLoginPage" className="btn btn-primary" onClick={()=>{history.push('/Login')}}>
                      Back To Login Page
                  </button>
             </div>                          
            </div>
          )}
          {showConfirmationMsg && (
            <div className="form-body">
            <div className="form-desc"> Password reset successful. </div>
            <div className="info-label"></div>
            <div  className="center-container">
                  <button id="btnBackToLoginPageAfterSuccess" className="btn btn-primary" onClick={()=>{history.push('/Login')}}>
                      Back To Login Page
                  </button>
             </div>                          
            </div>
          )}

        </form>
      </div>
    
  );
};

export default ResetPassComp;
